/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/naming-convention */
import {SECTION_CODE} from 'modules/product-card/constants';
import {
    PRODUCT_DESCRIPTION,
    PRODUCT_DESCRIPTION_LIST_COMMON,
    TProductDescriptionListCommon,
} from 'modules/product-card/constants/description';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {IProperty, IPropertyValue} from 'modules/products/types';
import DOMPurify from 'isomorphic-dompurify';

const {AKSESSUARY, STEKLO} = SECTION_CODE;

interface IGetProductDescriptionsListItem {
    code: string;
    isHTML: boolean;
    title: string;
    value: string;
}

const sanitizeHTML = (value: string): string => {
    return DOMPurify.sanitize(value);
};

const getResultTitle = (topSection: string, property: IProperty): string => {
    const {code, title} = property;

    if (code === PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS.CODE) {
        if (topSection === STEKLO || topSection === AKSESSUARY) {
            return 'Подходит для';
        }

        return 'Дегустационные характеристики';
    }

    return title;
};

const getValue = (property: IProperty): string => {
    if (!property) {
        return '';
    }

    const value = (property as any).value as unknown;

    if (null === value || value === undefined) {
        return '';
    }

    if (Array.isArray(value)) {
        return (value as unknown[]).join(', ');
    }

    if ('object' === typeof value) {
        return String((value as IPropertyValue).value);
    }

    return String(value);
};

export const getProductDescriptionsList = (product: IProduct): IGetProductDescriptionsListItem[] => {
    const topSection = product.topSection;
    const productProperties = product.properties as IProperty[];

    const list: TProductDescriptionListCommon = PRODUCT_DESCRIPTION_LIST_COMMON;
    const orderList: string[] = list.map(({CODE}) => CODE);

    const resultDescriptionList: IGetProductDescriptionsListItem[] = [];

    list.forEach(({CODE}) => {
        const property = productProperties.find(({code}) => code === CODE);

        if (!property) {
            return;
        }

        const valueFormatted = getValue(property);

        if (!valueFormatted) {
            return;
        }

        const resultTitle = getResultTitle(topSection, property);

        resultDescriptionList.push({
            code: CODE,
            isHTML: true,
            title: resultTitle,
            value: sanitizeHTML(valueFormatted),
        });
    });

    resultDescriptionList.sort((a, b) => {
        return orderList.indexOf(a.code) - orderList.indexOf(b.code);
    });

    return resultDescriptionList;
};
